/* FJX · Configuracion de GSAP. Se carga con defer justo despues de animations.min.js,
   asi corre antes que cualquier script de seccion que use GSAP (mismo orden que el tema original). */
(function () {
  if (!window.gsap) return;
  gsap.defaults({ ease: window.Power4 ? Power4.easeOut : 'power4.out' });
  gsap.config({ nullTargetWarn: false });
  if (window.ScrollTrigger) gsap.registerPlugin(ScrollTrigger);
})();
